<template>
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.0192 6.62046L14.4992 1.10046C14.4092 1.01046 14.2873 0.959839 14.1598 0.959839H5.51609C4.59172 0.959839 3.83984 1.70984 3.83984 2.63046V21.073C3.83984 22.1567 4.72484 23.0398 5.81422 23.0398H18.1855C19.2748 23.0398 20.1598 22.1567 20.1598 21.073V6.95984C20.1598 6.83234 20.1092 6.71046 20.0192 6.62046ZM12.4798 18.2398H8.15984V17.2798H12.4798V18.2398ZM15.8398 16.3198H8.15984V15.3598H15.8398V16.3198ZM15.8398 14.3998H8.15984V13.4398H15.8398V14.3998ZM15.8398 12.4798H8.15984V11.5198H15.8398V12.4798ZM15.2005 6.71984C14.758 6.71984 14.3998 6.36171 14.3998 5.91921V2.35859L18.7611 6.71984H15.2005Z"
              fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGDocument"
    }
</script>

<style scoped>

</style>
